import React, { useEffect, useState } from 'react'

const ModalItemSlider = () => {
    const [topvalue, setTopvalue] = useState(null);
    const [middlevalue, setMiddlevalue] = useState(null);
    const [bottomvalue, setBottomvalue] = useState(null);

    const shuffle = arr => [...arr].sort(() => Math.random() - 0.5);
    const l1 = []
    const l2 = []
    const l3 = []

    const lists = (v1, v2) => {
        let data = [];
        for (let index = v1; index < v2; index++) {
             data.push(index);
        }
         return data;
    }

    if(topvalue){
        topvalue.forEach((data, value) => {
            l1.push(<img id={data} src={process.env.PUBLIC_URL + "assets/models/images/" + data +".png"} alt={data} className='image-slider-auto mx-4' key={value} />)
        })
    }

    if(middlevalue){
        middlevalue.forEach((data, value) => {
            l2.push(<img id={data} src={process.env.PUBLIC_URL + "assets/models/images/" + data +".png"} alt={data} className='image-slider-auto mx-4' key={value} />)
        })
    }

    if(bottomvalue){
        bottomvalue.forEach((data, value) => {
            l3.push(<img id={data} src={process.env.PUBLIC_URL + "assets/models/images/" + data +".png"} alt={data} className='image-slider-auto mx-4' key={value} />)
        })
    }

    useEffect(() => {
        setTopvalue(shuffle(lists(0, 32)))
        setMiddlevalue(shuffle(lists(32, 65)))
        setBottomvalue(shuffle(lists(65, 97)))
    }, [])
    
    return (
        <>
            <div className="card border border-light shadow-0 mb-3">
                <div className="card-body">
                    <div className="home-goods-parent">
                        <div className="home-goods-child">{l1} </div>
                    </div>

                    <div className="home-goods-parent-middle">
                        <div className="home-goods-child-middle"> {l2} </div>
                    </div>

                    <div className="home-goods-parent">
                        <div className="home-goods-child"> {l3} </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModalItemSlider